import React from 'react'
import { Box } from '@mui/material'

export function Line(props) {
  return <Box component="hr" my={2} {...props} />
}
